module.exports = __webpack_public_path__ + "img/grand-spa.48912e06.jpg";